import { ref, markRaw } from 'vue'
import type { Component } from 'vue'

export interface DrawerState {
  open: boolean
  title?: string
  component: Component | null
  props?: Record<string, unknown>
  width?: number
}

const drawerState = ref<DrawerState>({
  open: false,
  title: '',
  component: null,
  props: {},
  width: 480,
})

export function useDrawer() {
  function openDrawer(options: Omit<DrawerState, 'open'>) {
    drawerState.value = {
      open: true,
      title: options.title,
      component: options.component ? markRaw(options.component) : null,
      props: options.props ?? {},
      width: options.width ?? 480,
    }
  }

  function closeDrawer() {
    drawerState.value.open = false
    // clear component to avoid holding references
    drawerState.value.component = null
  }

  return {
    drawerState,
    openDrawer,
    closeDrawer,
  }
}
